import { render, staticRenderFns } from "./AttachmentsPage.vue?vue&type=template&id=f6987dec&scoped=true&"
import script from "./AttachmentsPage.vue?vue&type=script&lang=js&"
export * from "./AttachmentsPage.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsPage.vue?vue&type=style&index=0&id=f6987dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6987dec",
  null
  
)

export default component.exports